import { render } from "./BrandCallMail.vue?vue&type=template&id=f7c25992"
import script from "./BrandCallMail.vue?vue&type=script&lang=ts"
export * from "./BrandCallMail.vue?vue&type=script&lang=ts"

import "./BrandCallMail.vue?vue&type=style&index=0&id=f7c25992&lang=scss"
script.render = render

export default script